<script>
	// https://svelte.dev/docs#createEventDispatcher
	// tutorial/05-events/04-component-events
	import { createEventDispatcher } from "svelte";
	const dispatch = createEventDispatcher();

	import UTILS from "./classes/utilities.js";

	//import Supplements from "./Supplements.svelte";

	//import PO from "./classes/ProductOrder.js";
	//import ProductOrder from "./ProductOrder.svelte";

	export let product;
	//export let supplements = [];

	function addToCart() {
		product.productOrders = product.productOrders || [];
		product.productOrders.push(new PO.ProductOrder(product));
		// product.productOrder = product.productOrder || new PO.ProductOrder(product);
		dispatch("addToCart", product);
		product = product;
	}
	function removeFromCart() {
		product.productOrders = product.productOrders || [];
		product.productOrder =
			product.productOrder || new PO.ProductOrder(product);
		dispatch("removeFromCart", product);
		product = product;
	}
</script>

<div class="product">
	<img
		src="/products/{product.id}.png"
		onerror="this.onerror=null; this.src='/products/empty.png'"
		width="75px"
		height="75px"
		alt={product.name}
	/>
	<p>{product.name}</p>
	<p class="price">{UTILS.formatMoney(product.price)}</p>
	<slot>empty</slot>
</div>

<style>
	.price::before {
		content: '€ ';
	}
	.product:nth-child(odd) {
		background-color: #eee;
	}

	.product {
		border: 2px solid black;
		display: flex;
	}
</style>
